<script setup lang="ts">
  import { MpButton, MpIconButton, MpInput, MpModal, MpText, pushToastMessage } from '@borg/ui';

  const i18n = useI18n();
  const { share, isSupported: isShareSupported } = useShare();
  const { copy, copied, isSupported: isCopySupported } = useClipboard();

  const link = ref('');
  const isOpen = ref(false);

  function onOpen() {
    link.value = window.location.href;
  }

  async function onShareLink() {
    try {
      await share({
        url: link.value,
      });
    } catch (e) {
      // prevent cancel share event going out to Sentry as an error
      console.log('Share cancelled');
    }
  }

  async function onCopyLink() {
    await copy(link.value);
    if (copied.value) {
      pushToastMessage({
        type: 'success',
        subtitle: i18n.t('JOB_DETAILS_PAGE.SHARE_MODAL.LINK_COPIED_SUCCESS_TOAST.SUBTITLE'),
      });
    }
  }

  function onShareButtonClick() {
    if (isShareSupported.value) {
      onShareLink();
    } else {
      isOpen.value = true;
    }
  }
</script>

<template>
  <MpIconButton
    icon="share"
    variant="secondary"
    data-test="job-share-button"
    @click="onShareButtonClick"
  />
  <MpModal
    v-model:is-open="isOpen"
    :title="$t('JOB_DETAILS_PAGE.SHARE_MODAL.TITLE')"
    size="sm"
    test="job-share-modal"
    @overlay-click="isOpen = false"
    @open="onOpen"
  >
    <div style="margin-bottom: var(--mp-space-50)">
      <MpInput
        :model-value="link"
        :label="$t('JOB_DETAILS_PAGE.SHARE_MODAL.LINK_LABEL')"
        readonly
      />
    </div>
    <MpButton
      v-if="isCopySupported"
      :text="$t('JOB_DETAILS_PAGE.SHARE_MODAL.BUTTON_COPY_TEXT')"
      is-full-width
      @click="onCopyLink"
    />
    <MpText
      v-else
      no-margin
    >
      {{ $t('JOB_DETAILS_PAGE.SHARE_MODAL.MANUAL_COPY_TEXT') }}
    </MpText>
  </MpModal>
</template>
